import { Component, Input } from '@angular/core';

type TabData = {
  icon: string;
  class?: string;
  color?: string;
  menuText: string;
  menuLink: string[];
  /** When true the tab is shown greyed-out and non-navigable (see disabledTooltip). */
  disabled?: boolean;
  /** Message shown on hover when the tab is disabled. */
  disabledTooltip?: string;
};

@Component({
    selector: 'menu-tabs',
    templateUrl: './menu-tabs.component.html',
    styleUrls: ['./menu-tabs.component.scss'],
    standalone: false
})
export class MenuTabsComponent {
  @Input() data: TabData[] = [];
}
